import { ProductVenderMappingService } from '../services/ProductVenderMappingService';
import { ProductVenderMappingConstants } from '../constants/ProductVenderMappingConstants';
import { alertActions } from '.';

export const ProductVenderMappingActions = {
  getAll,
  loadingData,
  exportData,
  ProductDDL,
  GetVendorListDDL,
  GetVendorProduct,
  createScheme,
  createMapping,
  UploadMapping,
};

function getAll(obj) {
  return dispatch => {
    dispatch(request());

    ProductVenderMappingService.fetchSecondaryPackingData(obj).then(response => {
      dispatch(loadingData(false));
      dispatch(success(response.ResponseData))


      // var data = response.ResponseData;   //Changes
      // if (data != null) {
      //   data.forEach(function (v) { delete v.TotalRows });
      // }
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }

    );
  };
  function request() { return { type: ProductVenderMappingConstants.GETALL_REQUEST } }
  function success(datas) { return { type: ProductVenderMappingConstants.GETALL_SUCCESS, datas } }
  function failure(error) { return { type: ProductVenderMappingConstants.GETALL_FAILURE, error } }
}

function GetVendorListDDL(UserId) {
  return dispatch => {
    dispatch(request());
    ProductVenderMappingService.GetVendorListDDL(UserId).then(response => {
      dispatch(loadingData(false));
      dispatch(success(response.ResponseData))
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() { return { type: ProductVenderMappingConstants.GETVENDORDDL_REQUEST } }
  function success(datas) { return { type: ProductVenderMappingConstants.GETVENDORDDL_SUCCESS, datas } }
  function failure(error) { return { type: ProductVenderMappingConstants.GETVENDORDDL_FAILURE, error } }
}

function GetVendorProduct(UserId) {
  return dispatch => {
    dispatch(request());
    ProductVenderMappingService.GetVendorProduct(UserId).then(response => {
      dispatch(loadingData(false));
      dispatch(success(response.ResponseData))
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() { return { type: ProductVenderMappingConstants.GETVENDORPRODUCT_REQUEST } }
  function success(datas) { return { type: ProductVenderMappingConstants.GETVENDORPRODUCT_SUCCESS, datas } }
  function failure(error) { return { type: ProductVenderMappingConstants.GETVENDORPRODUCT_FAILURE, error } }
}

function ProductDDL() {

  return (dispatch) => {
    dispatch(request());
    ProductVenderMappingService.ProductDDL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: ProductVenderMappingConstants.GETPDDL_REQUEST };
  }
  function success(datas) {
    return { type: ProductVenderMappingConstants.GETPDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ProductVenderMappingConstants.GETPDDL_FAILURE, error };
  }
}
function exportData(obj) {
  return dispatch => {
    dispatch(request());
    ProductVenderMappingService.GetSecondaryPackingReportExport(obj).then(response => {
      dispatch(loadingData(false));
      var data = response.ResponseData;
      if (data != null) {
        data.forEach(function (v) { delete v.TotalRows });
      }
      dispatch(success(data))
    },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      });
  };
  function request() { return { type: ProductVenderMappingConstants.GETEXPORT_REQUEST } }
  function success(datas) { return { type: ProductVenderMappingConstants.GETEXPORT_SUCCESS, datas } }
  function failure(error) { return { type: ProductVenderMappingConstants.GETEXPORT_FAILURE, error } }
}
function createScheme(data) {
  return dispatch => {
    dispatch(request(data));

    ProductVenderMappingService.createScheme(data).then(
      response => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(response.ResponseData));
            // dispatch(onHideShow(false));  // Close the dialog
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };



  function request(data) { return { type: ProductVenderMappingConstants.CREATE_REQUEST, data } }
  function success(data) { return { type: ProductVenderMappingConstants.CREATE_SUCCESS, data } }
  function failure(error) { return { type: ProductVenderMappingConstants.CREATE_FAILURE, error } }
};

function createMapping(formData) {
  return dispatch => {
    dispatch(request(formData));

    ProductVenderMappingService.createMapping(formData).then(
      response => {
        if (response && response.ResponseCode === "200") {
          dispatch(success(response.ResponseData));
          dispatch(alertActions.success(response.ResponseMessage));
          // Refresh the list after successful creation
          // dispatch(getAll(new tableRequest())); 
        } else {
          dispatch(failure(response.ResponseMessage));
          dispatch(alertActions.error(response.ResponseMessage));
        }
      },
      error => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: ProductVenderMappingConstants.CREATE_MAPPING_REQUEST, data }
  }
  function success(data) {
    return { type: ProductVenderMappingConstants.CREATE_MAPPING_SUCCESS, data }
  }
  function failure(error) {
    return { type: ProductVenderMappingConstants.CREATE_MAPPING_FAILURE, error }
  }
}

function UploadMapping(formData, tblResponse) {
  return (dispatch) => {
    dispatch(request());
    ProductVenderMappingService.UploadMapping(formData).then(
      (response) => {
        dispatch(success(response));
        if (response.ResponseCode == "200") {
          dispatch(alertActions.success(response.ResponseMessage.toString()));
          dispatch(getAll(tblResponse));
        } else if (response.ResponseCode == "201") {
          dispatch(alertActions.warning(response.ResponseMessage.toString()));
          dispatch(partial_success(response.ResponseData));
          dispatch(getAll(tblResponse));
        }
        else
          dispatch(alertActions.error(response.ResponseMessage.toString()));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: ProductVenderMappingConstants.UPLOAD_SO_REQUEST };
  }
  function success(datas) {
    return { type: ProductVenderMappingConstants.UPLOAD_SO_SUCCESS, datas };
  }
  function partial_success(datas) {
    return { type: ProductVenderMappingConstants.UPLOAD_SO_PARTIAL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: ProductVenderMappingConstants.UPLOAD_SO_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: ProductVenderMappingConstants.LOADING_REQUEST, isbool
  }
}
